import ZeroFundraiser from './zero_fundraiser'
import { connect } from 'react-redux'
import { formatMoney } from 'client/griffin'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { getBlockType } from 'lib/create_util'
import { getMinMaxAmount } from 'shared/helpers/campaign'
import { destroy } from 'redux-form'

const mapStateToProps = (state, props) => {
  const campaign = state.campaign[NEW_CAMPAIGN_ID]
  const isGNCEnabled = state.flags.is_gnc_enabled
  const countryCode = state.country.country_code || 'US'
  const gnHref = `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/basics`
  const gncHref = `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/nonprofit`
  const userHasCampaigns = false

  const minMaxAmount = getMinMaxAmount(campaign)
  const formattedMaxGoalAmount = minMaxAmount.MAX_AMOUNT
    ? formatMoney(campaign.currency, minMaxAmount.MAX_AMOUNT, {
        removeTrailingZeros: true,
      })
    : ''

  /**
   * Being an almost static page, this won't even be validated
   * but is required for create_type (CreateType) component
   * to work properly
   */
  const isCampaignLimitReached = false

  return {
    blockType: getBlockType(state, props, campaign),
    gnHref,
    gncHref,
    countryCode,
    isGNCEnabled,
    userHasCampaigns,
    formattedMaxGoalAmount,
    isCampaignLimitReached,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onComponentMount() {
      dispatch(destroy('crowdfunding_basics'))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ZeroFundraiser)
